import { gql } from "@apollo/client";

export const GENERATE_DOWNLOAD_LINK = gql`
  mutation GenerateDownloadLink($fileRequestId: ID!) {
    generateDownloadLink(fileRequestId: $fileRequestId) {
      url
      expiresAt
    }
  }
`;
